import { useState } from "react";
import MegaCampaigns from "./MegaCampaigns/MegaCampaigns";
import DailySales from "./DailySales/DailySales";
import EventSale from "./EventSale/EventSale";
import OrangeTabs from "../../../../components/WholesalerComponents/OrangeTabs/OrangeTabs";

const Campaigns = () => {
  const tabs = ["Mega Campaigns", "Daily Sales", "Events Sale"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div
      style={{
        background: "#f2f2f2",
        minHeight: "100dvh",
        padding: "1.25rem",
      }}
    >
      <h4 className="fw-semibold mb-3">Promotional Campaigns</h4>

      <OrangeTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
      />

      {activeTab === "Mega Campaigns" && <MegaCampaigns />}
      {activeTab === "Daily Sales" && <DailySales />}
      {activeTab === "Events Sale" && <EventSale />}
    </div>
  );
};

export default Campaigns;